export enum PermissionScope {

  ANY = 'ANY',
  CONTACT = 'CONTACT',
  // Kontakt Beziehungen / Relationen
  CONTACT_RELATION = 'CONTACT_RELATION',
  CONTACT_EMPLOYEE = 'CONTACT_EMPLOYEE',
  CONTACT_VEHICLE = 'CONTACT_VEHICLE', // Feature free
  CONTACT_VEHICLE_EXTENDED = 'CONTACT_VEHICLE_EXTENDED', // Feature paid
  INVOICE = 'INVOICE',
  INVOICE_CANCEL = 'INVOICE_CANCEL',
  INVOICE_PAYMENT = 'INVOICE_PAYMENT',
  OLD_PART = 'OLD_PART', // Feature
  RECEIPT = 'RECEIPT',
  RECEIPT_PAYMENT = 'RECEIPT_PAYMENT',
  ARTICLE = 'ARTICLE',
  CATALOG = 'CATALOG',
  VEHICLE = 'VEHICLE',
  SETTINGS = 'SETTINGS',
  SETTINGS_ORG = 'SETTINGS_ORG',
  SETTINGS_USER = 'SETTINGS_USER',
  SETTINGS_INVOICE = 'SETTINGS_INVOICE',
  SETTINGS_VAT_RATE = 'SETTINGS_VAT_RATE',
  STAHLGRUBER_CATALOG_IMPORT = 'STAHLGRUBER_CATALOG_IMPORT',
  FEATURE = 'FEATURE',
  BILLING = 'BILLING',
  STATISTICS = 'STATISTICS',
  ORG_WALLET = 'ORG_WALLET', // R=View wallet / RW=+Payment
  CORRESPONDENCE = 'CORRESPONDENCE', // Send Email, Letter, ...
  EXPORT = 'EXPORT', // This is a reserved scope / see Permissions and PermissionItem
  EXPORT_DATEV = 'EXPORT_DATEV',
  EXPORT_CSV = 'EXPORT_CSV',
  // Iron-Backup
  IRON_BACKUP = 'IRON_BACKUP',
  SUPPORT = 'SUPPORT',
  // Zeichnungsberechtigung fuer Vertragsdokumente
  AGREEMENT = 'AGREEMENT',
  // Sterbefall / Bestatter
  FUNERAL = 'FUNERAL',
  FUNERAL_EXTENDED = 'FUNERAL_EXTENDED',
  DOCUMENT = 'DOCUMENT',
}
